const applet = '/p/confirmar';
const view = `${applet}/cadastro/:cid`;

const urls = {
  get: {
    address: '/v1/pub/enderecos/:cep',
    studentByCpf: '/v1/organizacoes/:org/usuario_por_cpf/:cpf',
    confirmRegister: '/v1/pub/confirmacao_cadastro/:cid',
  },
  put: {
    confirmRegister: '/v1/pub/confirmacao_cadastro/:cid',
  },
  post: {
    student: '/v1/organizacoes/:org/formandos',
    profile: '/v1/all/perfil',
    saveAvatar: '/v1/all/avatar',
  },
  del: {
    student: '/v1/organizacoes/:org/formandos/:student',
  },
  combos: {
    phoneTypes: '/v1/pub/telefone_tipos',
    gender: '/v1/pub/sexos',
  },
};

export { applet, view, urls };
